<template>
    <component :is="template">
        <v-container>
            <v-row>
                <v-col>
                    <div class="contents-area">
                        <div class="contents-area__inner">
                            <div class="tit-wrap tit-wrap--unberline">
                                <v-row align="center">
                                    <v-col cols="12" md="">
                                        <h2 class="tit">배송상품</h2>
                                    </v-col>
                                    <v-col cols="12" md="auto">
                                        <v-text-field v-model="searchValue" name="searchValue" type="search" autocomplete="off" hide-details outlined placeholder="배송상품 검색" class="w-100 w-md-260px" @keydown.enter="() => $router.push(`./products/search?searchValue=${searchValue}&searchKey=name&page=1`)">
                                            <template v-slot:append>
                                                <v-icon v-show="searchValue" size="28" class="mr-1" @click="searchValue = null">mdi-close</v-icon>
                                                <v-icon size="28" @click="() => $router.push(`./products/search?searchValue=${searchValue}&searchKey=name&page=1`)">mdi-magnify</v-icon>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="font-size-14 font-size-md-16 grey--text text--garken-3 mt-md-n20px mb-20px mb-md-22px">
                                <p>* 모든 배송상품은 나누리 캐시로 교환 할 수 있는 상품입니다. 캐시 외에 구입 불가 합니다.</p>
                                <p>* 본인인증을 진행한 후 30분 동안 교환소 이용이 가능합니다.</p>
                                <p>* 교환 전 본인인증을 진행해 주세요.</p>
                            </div>

                            <!-- 배달상품 카테고리 -->
                            <delivery-navi />

                            <!-- 배달상품 리스트 -->
                            <delivery-list />
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-dialog v-if="!me?.ci && meLoaded" v-model="dialog" max-width="500" :width="$vuetify.breakpoint ? '50%' : '90%'" scrollable>
                <v-card>
                    <a href="/mypage/profile"><v-img src="/images/giftcard-popup3.jpg" /></a>
                    <div class="popup-layer-foot" style="display: flex; background-color: #424242; padding: 10px">
                        <v-spacer></v-spacer>
                        <v-btn text @click="close" style="color: white; font-size: 16px">닫기</v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </v-container>
    </component>
</template>
<script>
import api from "@/api";
import DeliveryNavi from "@/components/client/dshop/delivery-navi.vue";
import DeliveryList from "@/components/client/dshop/delivery-list.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";

export default {
    components: {
        DeliveryNavi,
        DeliveryList,
        PopupLayer,
    },
    data() {
        return {
            searchValue: null,
            dialog: true,

            me: null,
            meLoaded: false,
        };
    },
    async mounted() {
        await this.init();
    },
    created() {
        if (this.logoff) {
            const query = encodeURIComponent(`/dshop/products?_category&page=1`);
            this.$router.replace(`/login?to=${query}`);
        }
    },
    methods: {
        async init() {
            let { me } = await api.v1.me.profile.get();
            this.me = me;
            this.meLoaded = true;
        },
        close(){
            this.dialog = false
        }
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        accessToken() {
            return this.$store.state.accessToken;
        },
        logoff() {
            return !this.$store.state.accessToken;
        },
    },
    watch: {
        dialog() {
            if (!this.me.ci && !this.dialog) {
                this.$router.push("/mypage/profile");
            }
        },
        dialog(){
            if(!this.me.ci && !this.dialog){
                this.$router.push('/mypage/profile')
            }
        }
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 1024px) {
    .contents-area {
        padding: 60px 114px;
    }
}
</style>
